import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "showButton"]

  openSidebar() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.remove("hidden")

      // Hide show button when sidebar is opened
      if (this.hasShowButtonTarget) {
        this.showButtonTarget.classList.add("hidden")
      }

      // Dispatch event to notify sidebar is opened
      this.dispatch("opened", { bubbles: true })
    }
  }

  closeSidebar() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.add("hidden")

      // Show button when sidebar is closed
      if (this.hasShowButtonTarget) {
        this.showButtonTarget.classList.remove("hidden")
      }

      // Dispatch event to notify sidebar is closed
      this.dispatch("closed", { bubbles: true })
    }
  }

  toggleSidebar() {
    if (this.hasSidebarTarget) {
      const isHidden = this.sidebarTarget.classList.contains("hidden")
      this.sidebarTarget.classList.toggle("hidden")

      // Toggle show button visibility
      if (this.hasShowButtonTarget) {
        if (isHidden) {
          // Sidebar is being opened, hide button
          this.showButtonTarget.classList.add("hidden")
        } else {
          // Sidebar is being closed, show button
          this.showButtonTarget.classList.remove("hidden")
        }
      }

      // Dispatch appropriate event
      if (isHidden) {
        this.dispatch("opened", { bubbles: true })
      } else {
        this.dispatch("closed", { bubbles: true })
      }
    }
  }
}
